// TODO: We should remove all this logic since it's already handled by @mc/email-capture
import { useState } from 'react'
import Cookie from 'cookie-universal'
import { AUTH_TYPE } from '@mc/constants'
import { setFireEmailCaptureCookie } from '@mc/email-capture'
import { getFreeTrialOriginCartPropsAsync } from '@mc/free-trial'
import { usePrimaryCta } from '@mc/growth'
import { trackCartEmailCapturedOnHero } from '@mc/pre-paywall-events'
import { trackPurchaseClick } from 'libs/events'
import { checkEmail } from '../client/api/account'
import { ONE_DAY } from '../constants'

const CART_STATUS = 'cart_status'
const CART_EMAIL = 'cart_email'
const CART_LOAD_PROD = 'cart_load_prod'

const cookies = Cookie()

export const setLoadCartProductsCookie = () =>
  cookies.set(CART_LOAD_PROD, true, { maxAge: ONE_DAY })

const setCartStatusCookie = (status) =>
  cookies.set(CART_STATUS, status, { maxAge: ONE_DAY })

const removeCartStatusCookie = () => cookies.remove(CART_STATUS)

const setCartEmailCookie = (email) =>
  cookies.set(CART_EMAIL, email, {
    // TODO: this is a hot fix realated to PRC-140.
    // We should migrate rails to use cookie-universal, and delete
    // This dummy encode function.
    encode: (e) => e,
    maxAge: ONE_DAY,
  })

export const getCartEmailCookie = () =>
  cookies.get(CART_EMAIL)?.replace(/['"]+/g, '') || ''

export const useEmailCapture = () => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const { ctaHref } = usePrimaryCta()

  const onCheckEmail = async ({
    email,
    action,
    href = ctaHref,
    pageSource,
    nextCaptureMethod,
  }) => {
    setLoading(true)
    trackPurchaseClick({ email, action, href, pageSource })

    try {
      const res = await checkEmail(email)

      if (res.status === 200 || res.status === 404) {
        const freeTrial = await getFreeTrialOriginCartPropsAsync(false)

        await trackCartEmailCapturedOnHero({
          email,
          pageSource,
          nextCaptureMethod,
          ...freeTrial,
        })

        // When we open the cart we need a way to know which capture method the user used
        setFireEmailCaptureCookie({
          authType: AUTH_TYPE.EMAIL,
          captureMethod: nextCaptureMethod,
        })
      }

      if (res.status === 200) {
        if (res.data.is_facebook_login) {
          // user previously logged in with facebook, display FB login button
          setCartStatusCookie('facebook')
        } else {
          // require user to enter password
          setCartStatusCookie('existing')
        }
        setLoadCartProductsCookie()
        setCartEmailCookie(email)
        window.location.assign(ctaHref)
      } else if (res.status === 404) {
        // email not found, new user will complete registration after checkout
        removeCartStatusCookie()
        setCartEmailCookie(email)
        window.location.assign(ctaHref)
      } else {
        setError(true)
      }
    } catch (err) {
      setError(true)
    } finally {
      setLoading(false)
    }
  }

  return { loading, error, onCheckEmail }
}
